import { Message } from 'element-ui';
import cloneDeep from 'lodash/fp/cloneDeep';
import {
  getCmpCtypeByName,
  getCurCmpData,
} from '../../../utils/engineeringFun';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    // 左边树锚点跳转的id
    anchorPointId: '',
    // 左边树跳转的搜索关键词
    anchorKeyWord: '',
    /**
     * 左侧树控制数据
     */
    treeConfigData: [],
    // can页状态
    canPageStates: {},
    // 左侧树的数据对象列表
    treeDatabase: {},
    // 当前面板订阅
    panelSubscribe: null,
    // 通道订阅
    canSubscribe: [],
    // 面板开启的ack订阅
    ackSubscribe: null,
    // UDS开启的订阅
    udsSubscribe: [],
    // websocket
    SOCKET: null,
    // 当前面板的状态是否是打开状态
    curPanelStatus: false,
    // 当前工程的状态是否是打开状态
    curProjectStatus: false,
    echartResizeKey: 0,
    // 当前操作的面板id
    panelId: null,
    // 当前操作工程的id
    projectId: null,
    // 当前project的panel列表
    panelIdList: [],
    // cg组件列表数据
    panelDataCcg: [],
    leftStructure: [],
    // filterLeftStructure: [],
    leftDisplayType: 'all', // 默认为all
    dragTreeNodeType: -1,
    // 被拖拽节点的key
    dragTreeNodeKey: '',
    // 设备列表
    deviceListOptions: [],
    // 面板数据
    panelList: [],
    // 保存发送面板数据
    allTreeNodeList: window.sessionStorage.getItem('allTreeNodeList'),
    // 保存左侧树状展开结构
    sendMsg: [],
    // 保存发送消息
    panelChanged: false, // 当前面板是否有变化
    displayDetailTabIndex: 0,
    a2lBindEventData: {
      columns: [],
      data: [],
    },
    initPanelDataObj: {},
    // 单绑定组件的信息
    singleBindValue: {
      maxValue: 0,
      minValue: 0,
      value: 0,
    },
    socket: {},
    stompClient: {},
    rightAsideComponentName: 'init', // 指明当前点击的组件类型
    // 组件样式信息（用于组件的标题等展示）
    componentStyleInfoArray: {
      init: { asideTitle: '页面设置' },
      signalCmp: { title: '双y轴示波图', asideTitle: '示波折线图' },
      dashboard: { title: '仪表盘', asideTitle: '仪表盘' },
      singleBind: { title: '标定量输入组件', asideTitle: '标定量输入组件' },
      submitCmp: { title: '发送', asideTitle: '发送' },
    },
    // 当前被点击的cmp index
    activedClickCmp: {
      signalCmp: 0,
      dashboard: 0,
      singleBind: 0,
      submitCmp: 0,
    },
    // 通道id与标定量组件的bind {canid: [singleBindIndex]}
    canBindSingleBind: {},
    // 组件的id与button的对应关系 {singleBindIndex: 'job'}
    singleBindStatus: {},
    // 在面板中各个组件的高度和宽度
    componentStyle: {
      signalCmp: { w: 12, h: 6 },
      dashboard: { w: 6, h: 4 },
      singleBind: { w: 6, h: 4 },
    },
    PANELCOLWIDTH: 12,
    // 当前组件的x和y坐标
    curComponentX: 0,
    curComponentY: 0,
    // 组件位置style
    cmpPositionStyle: [],
    // UDS诊断的响应
    udsResponse: new Map(),
    // UDS收到数据后的Tracker
    udsTracker: 0,
    // 标定量的initvalues列表
    initValues: JSON.parse(window.sessionStorage.getItem('initValues')),
    // OTA订阅
    OTASubscribe: {},
    sendSubscription: new Map(),
    cmpSyncKey: 0,
    controlSyncKey: 0,
    controlSyncKeyList: [],
    selectedCpts: [],
    bindIniSubscription: null,
    // bindIniSubscription: new Map(),
    bindIniKey: 0,
  },
  getters: {
    // 根据key返回左边树的数据结构
    getTreeData: state => key => state.treeDatabase[key],
    // 当前组件的状态
    // getCurCmpStatus: state => state.curPanelStatus,
    getCurCmpStatus: state => state.curProjectStatus,
    getPanelData_cg: state => state.panelDataCcg,
    getPanelList: state => state.panelList,
    // 过滤树节点
    filterLeftStructure: (state) => {
      const { leftStructure, leftDisplayType } = state;
      const tempStructure = cloneDeep(leftStructure);
      switch (leftDisplayType) {
        case 'all':
          return leftStructure;
        case 'DBC':
        case 'A2L':
          tempStructure.forEach((item) => {
            if (item.children) {
              for (let i = 0; i < item.children.length; i += 1) {
                if (item.children[i].text.toUpperCase() !== leftDisplayType.toUpperCase()) {
                  item.children.splice(i, 1);
                  i -= 1;
                }
              }
            }
          });
          console.log(tempStructure);
          return tempStructure;
        default:
          return leftStructure;
      }
    },
    // 生成信号数组
    // 数组结构
    // canName
    //   ECUs
    //   system variables
    //   DBC
    //     message
    //       messageNode
    //         signalNumber
    //     signal
    //       signalNumber
    //   A2L
    //     标定量
    //       signalNumber
    //     观测量
    //       signalNumber
    canSignalArr: (state) => {
      const { leftStructure } = state;
      const canSignalArr = [];
      leftStructure.forEach((canItem) => {
        const canSignalArrObj = {
          id: canItem.id, // canname
          signalArr: {},
        };
        canItem.children.forEach((canChildItem) => {
          canChildItem.children.forEach((leafNodeItem) => { // message, signal, 标定量, 观测量
            leafNodeItem.children.forEach((signalItem) => {
              canSignalArrObj.signalArr[signalItem.id] = JSON.parse(JSON.stringify(signalItem));
              // 如果是message的子节点，当前节点是messagenode，还有信号的子节点
              if (signalItem.type === 6) {
                signalItem.children.forEach((leafSignalItem) => {
                  canSignalArrObj.signalArr[leafSignalItem.id] = JSON.parse(JSON.stringify(leafSignalItem));
                });
              }
            });
          });
        });
        canSignalArr.push(canSignalArrObj);
      });
      return canSignalArr;
    },
    // 当前面板的所有数据
    activedPanelData: state => getCurCmpData(state),
    // 当前面板中被点击模块
    activedCmpInPanel: (state, getters) => {
      const { activedPanelData } = getters;
      const { rightAsideComponentName, activedClickCmp } = state;
      let cmpIndex = -1;
      if (activedClickCmp[rightAsideComponentName] !== undefined) {
        cmpIndex = activedClickCmp[rightAsideComponentName];
      }
      if (cmpIndex > -1 && activedPanelData[rightAsideComponentName]) {
        return activedPanelData[rightAsideComponentName][cmpIndex];
      }
      return {};
    },
    // 当前面板所有组件位置的position for vue-grid-layout
    gridLayoutObj: (state) => {
      const { cmpPositionStyle } = state;
      const tempLayoutObj = { cmpName: [], position: [] };
      if (cmpPositionStyle.length) {
        cmpPositionStyle.forEach((item) => {
          tempLayoutObj.cmpName.push(item.cmpName);
          tempLayoutObj.position.push(item.position);
        });
      }
      return tempLayoutObj;
    },
    getPanelId: state => state.panelId,
    getUdsResponse: state => state.udsResponse,
    getUdsTracker: state => state.udsTracker,
    getAllTreeNodeList: state => (state.allTreeNodeList === null ? '' : state.allTreeNodeList),
    getAnchorKeyWord: state => state.anchorKeyWord,
    getInitValues: state => state.initValues,
  },
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/engineering/index.js